module.exports = "\r\n<p-progressBar mode=\"indeterminate\" [style]=\"{'height': '6px','margin':'4px 0px'}\"></p-progressBar>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/loader/progress.component.html
// module id = ./src/app/components/utility/loader/progress.component.html
// module chunks = main